// extracted by mini-css-extract-plugin
module.exports = {"card":"NoAFJq1ToY3Ifu351AIH","sendButton":"TfrjdzkcEPSki5hjE5qp"};